import { ConfigProvider } from 'tea-component';
import { FormatOptionsParamsType } from '@/pages/dashboard/components/NewFilter/_type';
import React from 'react';
import { LANGUAGE_CN } from '@/pages/dashboard/_config/constant';
import SelectorMultiple from '@/pages/dashboard/components/NewSelectorMultiple';

import en_US from "tea-component/es/i18n/locale/en_US";
import zh_CN from "tea-component/es/i18n/locale/zh_CN";
import './filterList.scss';

const formatSourceOption = (config: FormatOptionsParamsType) => {
  const { options, valueKey, locale, cnKey = '', enKey = '', contentKey = '' } = config;
  const optionsVal = options?.filter(item=>item?.churn_level !== '255') || [];
  return (optionsVal || []).map((item: any) => {
    const text = (locale === LANGUAGE_CN ? item?.[cnKey] : item?.[enKey]) || item?.[enKey] || item?.[cnKey];
    const content = contentKey + item?.[enKey].replace(/\s/g, "_");
    const value = item?.[valueKey];
    return {
      ...item,
      value,
      text,
      content
      // icon: item?.[iconKey] || importSvg(value),
    };
  });
};

export const renderChurnLevel = (props: any): React.ReactElement => {
  const { key, value, options, defaultValue, onChange, locale, getLocalText, name, allInfo, ...restProps } = props || {};
  // Churn Level
  return <ConfigProvider locale={locale === 'en-US' ? en_US : zh_CN}>
    <SelectorMultiple
      matchButtonWidth
      className='search-item'
      key={key}
      showTips={false}
      label={name || getLocalText('common_Churn_level', {}, false)}
      allDescribe={getLocalText('selector_multiple_component_network_all_describe', {}, false)}
      allInfo={allInfo || getLocalText('selector_multiple_component_churn_level_all_info', {}, false)}
      value={value}
      onChange={(value) => { onChange(key, value) }}
      options={formatSourceOption({
        options,
        locale,
        valueKey: 'churn_level',
        cnKey: 'churn_level_ch',
        enKey: 'churn_level_en',
        contentKey: 'engagement_churn_content_'
      })}
      {...restProps}
    />
  </ConfigProvider>;
};
